import type { Tables } from "@/integrations/supabase/types";

interface PropertyStatsProps {
  properties: Tables<"real_estate_properties">[];
}

export const PropertyStats = ({ properties }: PropertyStatsProps) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
      {[
        { label: "Total Properties", value: properties?.length || 0 },
        { label: "Average Price", value: `GHS ${properties ? (properties.reduce((acc, prop) => acc + prop.price, 0) / properties.length).toLocaleString() : 0}` },
        { label: "Available for Collateral", value: properties?.filter(p => p.collateral_value).length || 0 },
        { label: "Locations", value: properties ? new Set(properties.map(p => p.location)).size : 0 }
      ].map((stat, index) => (
        <div key={index} className="bg-primary/5 rounded-lg p-4">
          <div className="text-sm text-muted-foreground">{stat.label}</div>
          <div className="text-2xl font-semibold">{stat.value}</div>
        </div>
      ))}
    </div>
  );
};